import { getUserSystem, getUserSystemAll, getCodeInfo } from "@/api/dashboard";
import { getLockStateApi } from "@/api/common";

import { getTerminalType } from '@/utils'

const systems = {
  state: {
    systemList: [],
    systemListAll: [],
    codeInfo: {
      codeImageUrl: '',
      detailImageUrl: ''
    },
    systemType: 'pc',
    systemId: 15,
    isSafing: false,
    isSystemLock: false
  },
  getters: {
    getSystemList({ systemList }) {
      return systemList
    }
  },
  mutations: {
    SET_ISSAFING: (state, val) => {
      state.isSafing = val
    },
    SET_SYSTEMID: (state, val) => {
      state.systemId = val
    },
    SET_SYSTEMLIST: (state, list) => {
      state.systemList = list
    },
    SET_SYSTEMLISTALL: (state, list) => {
      state.systemListAll = list
    },
    SET_systemType: (state, type) => {
      state.systemType = type
    },
    SET_CODEINFO: (state, type) => {
      state.codeInfo = type
    },
    SET_SYSLOCKSTATE(state, flag) {
      state.isSystemLock = flag
    }
  },
  actions: {
    setSafe({ commit }, val) {
      return new Promise(resolve => {
        commit('SET_ISSAFING', val) // 开发用
        resolve()
      })
    },
    setSystemId({ commit }, val) {
      return new Promise(resolve => {
        commit('SET_SYSTEMID', val) // 开发用
        resolve()
      })
    },
    getSystem({ commit }) {
      return new Promise(resolve => {
        // getCodeInfo().then(res => {
        // commit('SET_CODEINFO', res.data)
        getUserSystem().then(res => {
          commit('SET_SYSTEMLIST', res.data)
          getLockStateApi().then(newRes => {
            commit('SET_SYSLOCKSTATE', newRes.data)
            resolve(false)
          })
        })
        getUserSystemAll().then(res => {
          commit('SET_SYSTEMLISTALL', res.data)
        })
      })
    },
    getSystemType({ commit }) {
      return new Promise(resolve => {
        getTerminalType().then(res => {
          commit('SET_systemType', res)
          resolve(res)
        })
      })
    }
  }
}

export default systems
